var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":_vm.isSplitView ? 6 : 12}},[_c('SecretsList')],1),(_vm.isSplitView)?_c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('SecretsList')],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }